import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ExplosiveShardsAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number
) => {
  const shardCount = 40;
  const t = timeSeconds;
  for (let i = 0; i < shardCount; i++) {
    const ang = (i / shardCount) * Math.PI * 2;
    const force = config.shatterForce ?? 20;
    const dist = e.maxRadius + t * force * 20;
    const r = getRadiusAtAngle(ang, e, dist);
    const sx = clampX(e.pos.x + Math.cos(ang) * r);
    const sy = clampY(e.pos.y + Math.sin(ang) * r);
    ctx.beginPath(); ctx.moveTo(sx, sy);
    ctx.lineTo(sx + 15 * Math.cos(ang + 0.5), sy + 15 * Math.sin(ang + 0.5));
    ctx.lineTo(sx + 15 * Math.cos(ang - 0.5), sy + 15 * Math.sin(ang - 0.5));
    ctx.closePath(); ctx.fill();
  }
};

registerBlastAnimation('EXPLOSIVE_SHARDS', ExplosiveShardsAnimation);
